import React, { Component } from 'react';
import { Button, InputGroupAddon, InputGroup, Input } from 'reactstrap';

const opts = {
  ...(new Intl.NumberFormat().resolvedOptions()),
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  minimumIntegerDigits: 2
};
const numberFormat = new Intl.NumberFormat(opts.locale, opts);

export default class extends Component {
  constructor (props) {
    super(props);

    this.state = {
      def: true,
      marca: props.defaultValue
    };
  }

  handleMarca = e => {
    this.setState({
      def: false,
      marca: e.target.value
    });
  };

  static getDerivedStateFromProps({ defaultValue, options }, { marca, def }) {
    if (def) {
      if (defaultValue !== marca) {
        return {
          marca: defaultValue
        };
      } else if (options && 0 < options.length && options[0].id !== marca) {
        return {
          marca: options[0].id
        };
      }
    }
    return null;
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.onSubmit({ value: this.state.marca });
  }

  render () {
    const { options, defaultValue, disabled } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <InputGroup size="sm">
          <Input disabled={disabled}  type="select" required defaultValue={defaultValue} onChange={this.handleMarca}>
            {!!options && options.map((v, i) => (
              <option key={i} value={v.id}>{numberFormat.format(v.preco)} | {v.nome}</option>
            ))}
          </Input>
          <InputGroupAddon addonType="append"><Button disabled={disabled} color="success" type="submit"><span className="fa fa-plus"></span></Button></InputGroupAddon>
        </InputGroup>
      </form>
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/consumo/SolicitacaoAguaMineral.js